import fetch from "../../../utils/fetch";

import locationObservations from "./locationObservations";
import locationAssignments from "./locationAssignments";

const stateInitial = {
  id: null,
  isLoading: false,
  editIsLoading: false,
  details: null,
  message: null,
  messageType: null,
  ...locationObservations.state,
  ...locationAssignments.state,
};

const getters = {
  // ID is bootstrapped from URL for sub tabs
  id: (state) => state.id,
  isLoading: (state) => state.isLoading,
  editIsLoading: (state) => state.editIsLoading,
  details: (state) => state.details,
  message: (state) => state.message,
  messageType: (state) => state.messageType,
  isManager: (state, getters, rootState, rootGetters) => {
    if (
      !state.details ||
      !state.details.project ||
      !state.details.project.id ||
      !rootGetters["user/profile/membershipMap"]
    ) {
      return false;
    }
    const projectId = state.details.project.id;
    if (!rootGetters["user/profile/membershipMap"][projectId]) {
      return false;
    }
    const projectMembership =
      rootGetters["user/profile/membershipMap"][projectId];
    return projectMembership.isManager;
  },
  isMember: (state, getters, rootState, rootGetters) => {
    if (
      !state.details ||
      !state.details.project ||
      !state.details.project.id ||
      !rootGetters["user/profile/membershipMap"]
    ) {
      return false;
    }
    const projectId = state.details.project.id;
    if (!rootGetters["user/profile/membershipMap"][projectId]) {
      return false;
    }
    const projectMembership =
      rootGetters["user/profile/membershipMap"][projectId];
    return projectMembership.isMember;
  },
};

const t = {
  LOCATION_RESET: "LOCATION_RESET",
  LOCATION_SET_LOADING: "LOCATION_SET_LOADING",
  LOCATION_SET_MESSAGE: "LOCATION_SET_MESSAGE",
  LOCATION_SET: "LOCATION_SET",
  LOCATION_DELETED: "LOCATION_DELETED",
  LOCATION_SET_EDIT_LOADING: "LOCATION_SET_EDIT_LOADING",
};

const actions = {
  async fetchLocation({ commit, state }, id) {
    // If user directly switches between locations, clear everything
    if (state.id && state.id !== id) {
      commit(t.LOCATION_RESET);
    }
    commit(t.LOCATION_SET_LOADING, id);
    return fetch("/areas/" + id)
      .then((response) => response.json())
      .then((data) => {
        commit(t.LOCATION_SET, data);
      })
      .catch((e) => {
        console.log(e);
        const message = e && e.message ? e.message : e;
        commit(t.LOCATION_SET_MESSAGE, { message, type: "error" });
      });
  },
  async updateLocation({ commit, state }, location) {
    // Method can be called with or without an ID. Without ID on the location details page. With an ID from other pages. Make sure to catch failures and re-direct to the location details page.
    if (!location.id) {
      location.id = state.id;
    }
    commit(t.LOCATION_SET_EDIT_LOADING, location.id);
    return fetch("/areas/" + location.id, {
      method: "PUT",
      body: JSON.stringify({
        name: location.name,
        lngLat: location.lngLat,
        updateObservations: location.updateObservations ? location.updateObservations : undefined,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        commit(t.LOCATION_SET, data);
      })
      .catch((e) => {
        const message =
          e.message.message || e.message || "Error updating location";
        commit(t.LOCATION_SET_MESSAGE, { message: message, type: "error" });
        throw e;
      });
  },
  async deleteLocation({ commit, state }, id) {
    // Method can be called with or without an ID. Without ID on the location details page. With an ID from other pages. Make sure to catch failures and re-direct to the location details page.
    if (!id) {
      id = state.id;
    }
    commit(t.LOCATION_SET_LOADING, id);
    return fetch("/areas/" + id, { method: "DELETE" })
      .then((response) => {
        commit(
          "project/get/SET_PROJECT_ERROR",
          `Location ${state.details.name} deleted successfully.`,
          { root: true }
        );
        commit(t.LOCATION_DELETED);
      })
      .catch((e) => {
        const message =
          e.message.message || e.message || "Error deleting location";
        commit(t.LOCATION_SET_MESSAGE, { message: message, type: "error" });
        throw e;
      });
  },
};
const mutations = {
  [t.LOCATION_RESET](state) {
    state = { ...stateInitial };
  },
  [t.LOCATION_SET_LOADING](state, id) {
    state.id = id;
    state.details = null;
    state.isLoading = true;
    state.message = null;
  },
  [t.LOCATION_SET](state, location) {
    state.details = location;
    state.isLoading = false;
    state.editIsLoading = false;
    state.message = null;
    state.messageType = null;
  },
  [t.LOCATION_SET_MESSAGE](state, { message, type }) {
    state.isLoading = false;
    state.message = message;
    state.messageType = type;
  },
  [t.LOCATION_DELETED](state) {
    const name = state.details.name;
    state.details = null;
    state.id = null;
    state.isLoading = false;
    state.message = `Location ${name} deleted successfully.`;
    state.messageType = "success";
  },
  [t.LOCATION_SET_EDIT_LOADING](state, id) {
    state.id = id;
    state.editIsLoading = true;
    state.message = null;
    state.messageType = null;
  },
};

export default {
  namespaced: true,
  state: {
    ...stateInitial,
  },
  getters: {
    ...getters,
    ...locationObservations.getters,
    ...locationAssignments.getters,
  },
  actions: {
    ...actions,
    ...locationObservations.actions,
    ...locationAssignments.actions,
  },
  mutations: {
    ...mutations,
    ...locationObservations.mutations,
    ...locationAssignments.mutations,
  },
};
